var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C7C7C7;}\n\t.st1{fill:#D9000D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    className: "st0",
    d: "M4.47,17.11l-2.58-2.46c10.29-9.66,26.32-9.66,36.61,0l-2.58,2.46 C27.08,8.82,13.32,8.82,4.47,17.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    className: "st0",
    d: "M8.85,21.88l-2.61-2.46c7.9-7.25,20.03-7.25,27.93,0l-2.61,2.46 C25.13,15.98,15.26,15.98,8.85,21.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    className: "st0",
    d: "M14.3,27.06l-2.46-2.46c4.62-4.61,12.1-4.61,16.72,0l-2.46,2.46 C22.83,23.81,17.56,23.81,14.3,27.06z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_346",
    className: "st0",
    cx: 20.15,
    cy: 29.72,
    rx: 3.09,
    ry: 3.09
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_97",
    transform: "translate(-358.019 -412.527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_641",
    x: 366.1,
    y: 433.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -203.004 389.0768)",
    className: "st1",
    width: 4.11,
    height: 11.58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_642",
    x: 362.37,
    y: 437.53,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -203.0036 389.0763)",
    className: "st1",
    width: 11.58,
    height: 4.11
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWifi);
export default __webpack_public_path__ + "static/media/no_wifi.8abf87158b76c5fbe1eb5e4ecef23e44.svg";
export { ForwardRef as ReactComponent };